import { AppContext } from "@lightspeed-invoicing/core-client/frontend/index"
import Payment from "../../state/payment/Payment"
import { HttpError, isError } from "../helpers/Error"
import HttpClient from "../helpers/HttpClient"
import { CreditMemoElastic } from "../listing/credit-memo/models/creditMemoElastic"
import { PaymentElastic } from "../listing/payment/models"
import { PaymentDto } from "./Payment"

type UpdatePaymentPayload = {
    contactId: string
}

class PaymentService {
    static httpClient: HttpClient<Payment, PaymentDto> = new HttpClient<Payment, PaymentDto>(Payment)

    static async getPayment(paymentId: string): Promise<Payment | HttpError> {
        const res = await this.httpClient.get("/payments/" + paymentId)
        if (isError(res)) {
            return res as HttpError
        }
        return res as Payment
    }


    static getCreditMemoPerPaymentId = async (paymentId : string) => {
        if(paymentId != "") {
            const postData = {
                keywords: "*",
                objects: ["credit-memos"],
                fields: [],
                pageSize: 1,
                activePage: 1,
                sortByField: "createdAt",
                sortAsc: false,
                filters: {
                    createdFromPaymentId: paymentId,
                },
                lightResult: true,
            }
            const res =  await AppContext.getApiClient().post("/listing/search", postData)
            return res.data[0] as CreditMemoElastic
        }
        return undefined
    }

    static getCreditMemosByIds = async (creditMemoIds: string[]): Promise<CreditMemoElastic[]> => {
        const postData = {
            keywords: "*",
            objects: ["credit-memos"],
            fields: [],
            pageSize: 25,
            activePage: 1,
            sortByField: "createdAt",
            sortAsc: false,
            filters: {
                "_id": creditMemoIds
            },
            lightResult: true,
        }
        const res = await AppContext.getApiClient().post("/listing/search", postData)
        return res.data as CreditMemoElastic[]
    }

    static getPaymentPerOriginalPaymentId = async (paymentId : string) => {
        if(paymentId != "") {
            const postData = {
                keywords: "*",
                objects: ["payments"],
                fields: [],
                pageSize: 25,
                activePage: 1,
                sortByField: "createdAt",
                sortAsc: false,
                filters: {
                    "originalPaymentId.keyword": paymentId,
                },
                lightResult: true,
            }
            const res =  await AppContext.getApiClient().post("/listing/search", postData)
            return res.data as PaymentElastic[]
        }
        return undefined
    }
    
    static updatePayment = async (paymentId: string, update: UpdatePaymentPayload) => {
        const res =  await AppContext.getApiClient().patch(`/payments/${paymentId}`, update)

        if (res.error) {
            return res.error
        }

        return res.data as Payment
    }
}

export default PaymentService


// WEBPACK FOOTER //
// ./src/state/payment/PaymentService.ts